/**
* Anchor Nav JS
* -----------------------------------------------------------------------------
*
* All the JS for the Anchor Nav component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin( ScrollTrigger );
gsap.registerPlugin( ScrollToPlugin );
( function( app ) {
  const COMPONENT = {

    className: 'anchor-nav',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let navHeight = $( '.navbar' ).outerHeight();
      let triggerPos = $( '.anchor-nav' ).outerHeight();

      if ( $( '#wpadminbar' ).length ) {
        navHeight += $( '#wpadminbar' ).outerHeight();
      }

      triggerPos += navHeight;
      $( '.anchor-nav' ).css( {top: navHeight + 'px'} );

      $( 'section' ).each( function() {
        const href = $( this ).attr( 'id' );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top ' + triggerPos,
            end: 'bottom ' + triggerPos,
            scrub: 0,
            toggleClass: {
              targets: $( '.anchor-nav a[href="#' + href + '"]' )[0],
              className: 'is-active',
            },
          },
        } );
      } );

      $( '.anchor-nav a' ).click( function( e ) {
        if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
          let target = $( this.hash );
          let wpadminBarHeight = 0;
          if ( $( '#wpadminbar' ).length > 0 ) {
            wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
          }
          const headerHeight = $( 'header.navbar' ).outerHeight();
          target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) +']' );
          if ( target.length ) {
            e.preventDefault();
            const scrollMargin = parseInt( window.getComputedStyle( $( this.hash )[0] ).scrollMargin ) + 24;
            gsap.to( window, {
              duration: 1,
              scrollTo: {y: this.hash, offsetY: scrollMargin},
            } );
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'anchor-nav', COMPONENT );
} )( app );
